"use client";

import { useEffect, useRef } from "react";

/**
 * Landing demo preloader: fires once after `document.fonts.ready` (when available)
 * and two animation frames — approximate REFERENCE Preloader idle gate without
 * coupling to battle overlays.
 */
export function useLandingPreloaderReadiness(onReady: () => void): void {
	const onReadyRef = useRef(onReady);
	onReadyRef.current = onReady;

	useEffect(() => {
		let cancelled = false;

		const finish = () => {
			if (cancelled) {
				return;
			}
			onReadyRef.current();
		};

		const run = async () => {
			try {
				await document.fonts?.ready;
			} catch {
				/* ignore */
			}
			requestAnimationFrame(() => {
				requestAnimationFrame(finish);
			});
		};

		void run();

		return () => {
			cancelled = true;
		};
	}, []);
}
